import _ from 'lodash';
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import analytics from '../middleware/redux-analytics';
import { handleAnalyticsEvent } from '../analytics';
import rootReducer from '../reducers'

function setUrl(state) {
  window.history.pushState(null, null, formSearch({
    lat: state.cart[0].mapCenter.lat.toFixed(4),
    lng: state.cart[0].mapCenter.lng.toFixed(4),
    zoom: state.cart[0].mapZoom,
    mapStyle: state.cart[0].mapStyle,
    header: state.cart[0].labelHeader,
  }));
}
const debouncedSetUrl = _.debounce(setUrl, 10);

const configureStore = preloadedState => {
  const middlewares = [];

  if (process.env.NODE_ENV === 'development') {
    const createLogger = require('redux-logger');
    const logger = createLogger();
    middlewares.push(logger);
  }
  middlewares.push(thunk);

  const analyticsMw = analytics((analyticsInfo, state) => {
    // No need to wait for these to finish
    handleAnalyticsEvent(analyticsInfo, state);
  });
  middlewares.push(analyticsMw);

  const locationMiddleware = store => next => action => {
    setTimeout(() => {
      const state = store.getState();
      debouncedSetUrl(state);
    }, 0);

    next(action);
  };
  middlewares.push(locationMiddleware);

  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(...middlewares)
    )
  );

  return store;
}

function formSearch(obj) {
  const querys = _.map(obj, (val, key) => `${key}=${val}`).join('&')
  return `?${querys}`;
}

export default configureStore;


// WEBPACK FOOTER //
// ./src/store/configure.js